<template>
  <div class="skeleton__container">
    <div v-for="part in [1, 2]" :key="part" class="skeleton__part">
      <div class="skeleton-box skeleton__title" />
      <div class="skeleton__list-item">
        <div
          v-for="item in [1, 2, 3, 4, 5, 6, 7, 8, 9]"
          :key="item"
          class="skeleton__item skeleton-box"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.skeleton {
    &__container {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 80px;
        overflow: hidden;
    }

    &__part {
      display: flex;
      flex-direction: column;
      gap: 14px;
    }

    &__list-item{
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 12px;
    }

    &__title {
        width: 100px;
        height: 24px;
        border-radius: 8px;
    }

    &__item {
        width: 60px;
        height: 90px;
        border-radius: 12px;
    }
}
</style>
